import { FeatureFlag } from '@caresend/types';
import { initFetchWithRelationshipsConfig, setFWRLoggingMeta } from '@caresend/utils';
import { decryptData } from '../../../database/encryption/decrypt.js';
import { getEncryptionCachedData } from '../../../database/encryption/caching.js';
import 'js-sha256';
import '../../../database/firebaseConfig/cloudFunctions.js';
import { getStore } from '../../helpers/initStore.js';
import '../../../database/encryption/model.js';
import 'firebase/auth';
import '../../../database/firebaseConfig/init.js';
import { firebaseBind, getValueOnce, firebaseUnbind } from '../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../../components/ui/Icon.vue.js';
import '../../../functions/configuration/icons.js';
import '../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../functions/tracking/index.js';
import '../../../router/helpers/initRouter.js';
import '@firebase/auth';
import { isStorybook } from '../../../database/firebaseConfig/helpers.js';
import 'browser-image-compression';
import 'firebase/storage';
import { flagOn } from '../variables/index.js';

const isExactTheme = () => getStore().state.app.theme === 'exact';
const logAppVersion = () => {
    if (!isStorybook) {
        const version = process.env.VUE_APP_VERSION;
        const hash = process.env.VUE_APP_CI_COMMIT_SHORT_SHA || 'local';
        console.info(`${version}-${hash}`);
    }
};
const getLoggingMeta = () => ({
    globalVerbose: flagOn(FeatureFlag.FRONTEND_VERBOSE_FWR),
});
const initFWRAndVars = async () => {
    initFetchWithRelationshipsConfig({
        bind: firebaseBind,
        decryptData,
        getValueOnce,
        unbind: firebaseUnbind,
        encryptionCacheService: getEncryptionCachedData,
    });
    await getStore().dispatch('variables/bindVariables');
    setFWRLoggingMeta(getLoggingMeta());
};

export { getLoggingMeta, initFWRAndVars, isExactTheme, logAppVersion };
